import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function DesignMenu(props) {
  return (
    <Dropdown
      menuKey="design"
      menu={projectMenus.design}
      {...props}
    />
  );
}
